import React from 'react';
import { VStack } from 'native-base';
import { MenuSortKey, SortByProp, SortDirection, useDutchieStore } from '@springbig/shared';
import { H3 } from '~/shared/Typography';
import { Modal, Button } from '~/shared/Theme';

export type SortByModalProp = {
    showSortBy: boolean;
    setShowSortBy: (arg: boolean) => void;
};

export const SortByModal = ({ showSortBy, setShowSortBy }: SortByModalProp) => {

    const { setSortByProp } = useDutchieStore();

    const sortOptions : SortByProp[] = [
        { menuSort: { key: MenuSortKey.Potency, direction: SortDirection.Desc }, label: 'potency: high to low' },
        { menuSort: { key: MenuSortKey.Potency, direction: SortDirection.Asc }, label: 'potency: low to high' },
        { menuSort: { key: MenuSortKey.Popular, direction: SortDirection.Desc }, label: 'popular first' },
        { menuSort: { key: MenuSortKey.Price, direction: SortDirection.Desc }, label: 'price: high to low' },
        { menuSort: { key: MenuSortKey.Price, direction: SortDirection.Asc }, label: 'price: low to high' },
    ];

    return (
        <Modal isOpen={showSortBy} closeable onClose={() => setShowSortBy(false)}>
            <Modal.Header>
                <H3 m={0}>
                    sort by
                </H3>
            </Modal.Header>
            <Modal.Body>
                <VStack space={4}>
                    { sortOptions.map((item, index) =>

                        <Button
                            key={index}
                            text={item.label}
                            variant={'text'}
                            modifier={'small'}
                            onPress={() => {

                                setSortByProp(item);
                                setShowSortBy(false);
                            }}
                        />
                    )}
                </VStack>
            </Modal.Body>
        </Modal>
    );
};
